import React, { useState } from 'react'


import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'

import Select from '@material-ui/core/Select'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'

import UserAvatar from 'components/user/Avatar'

import settings from 'settings'

const MoreVertIcon = settings.icons.more

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  menu: {
    flexGrow: 0,
  },
  button: {
    flexGrow: 1,
  },
  avatarWrapper: {
    display: 'flex',
  },
  avatarName: {
    flex: 1,
    margin: theme.spacing(),
  },
  projectSelect: {
    color: theme.palette.primary.contrastText,
    '& svg': {
      color: theme.palette.primary.contrastText,
    },
    '&:before': {
      borderColor: theme.palette.primary.contrastText,
      borderBottom: [`1px solid ${theme.palette.primary.contrastText}`, '!important'],
      transition: 'none',
    },
    '&:after': {
      borderColor: theme.palette.primary.contrastText,
      borderBottom: [`1px solid ${theme.palette.primary.contrastText}`, '!important'],
      transition: 'none',
    },
  },
}))

const AppBarMenu = ({
  user,
  items,
  projects,
  activeProject,
  openPage,
  createProject,
  setActiveProject,
}) => {
  const classes = useStyles()

  const [ anchorEl, setAnchorEl ] = useState(null)

  const handleMenu = (event) => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)

  const clickItem = (item) => {
    if(typeof(item.handler) === 'string') {
      openPage(item.handler)
      handleClose()
    }
    else if(typeof(item.handler) === 'function') {
      item.handler()
      handleClose()
    }
    else {
      throw new Error(`unknown AppBarMenu item handler for ${item.title}`)
    }
  }

  const onChooseProject = (value) => {
    if(value == 'none') return
    if(value == 'add') createProject()
    else setActiveProject(value)
  }

  const value = activeProject ? activeProject.id : 'none'
  const open = Boolean(anchorEl)

  return (
    <div className={ classes.root }>
      {
        user && (
          <div className={ classes.menu }>
            <Select
              value={ value }
              onChange={ (ev) => onChooseProject(ev.target.value) }
              className={ classes.projectSelect }
            >
              {
                activeProject ? null : (
                  <MenuItem value="none">
                    Choose a workspace
                  </MenuItem>
                )
              }
              {
                projects.map((project, i) => (
                  <MenuItem 
                    key={ i }
                    value={ project.id }
                  >
                    { project.name }
                  </MenuItem>
                ))
              }
              <Divider />
              <MenuItem value="add">
                Add a workspace
              </MenuItem>
              
            </Select>
          </div>
        )
      }
      <div className={ classes.button }>
        <Button
          aria-owns={ open ? 'appbar-menu' : null }
          aria-haspopup="true"
          onClick={ handleMenu }
          color="inherit"
        >
          {
            user ? (
              <UserAvatar
                user={ user }
              />
            ) : (
              <MoreVertIcon />
            )
          }
        </Button>
        <Menu
          id="appbar-menu"
          anchorEl={ anchorEl }
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={ open }
          onClose={ handleClose }
        >
          <MenuItem key="placeholder" style={{display: "none"}} />
          {
            items.map((item, i) => {
              if(item === '-') {
                return (
                  <Divider key={ i } />
                )
              }
        
              return (
                <MenuItem
                  key={ i }
                  onClick={ () => clickItem(item) }
                >
                  {
                    item.icon && (
                      <ListItemIcon>
                        <item.icon />
                      </ListItemIcon>
                    )
                  }
                  <ListItemText 
                    primary={ item.title }
                  />
                </MenuItem>
              )
            })
          }
        </Menu>
      </div>
      
    </div>
  )
}

export default AppBarMenu